<template>
  <Descope
    flow-id="prod-login"
    @error="handleError"
    @success="async () => {Segment.trackUserGot('UniversalLoginMobileSuccess');
    }"
  />
</template>

<script setup>
import { Descope } from '@descope/vue-sdk';
import DDLogs from '../../DDLogs';
import Segment from '../../Segment';

Segment.trackUserGot('UniversalLoginMobileStart');

const handleError = e => {
  DDLogs.error('Could not log to Descope flow', e);
};

</script>

<style lang="scss" scoped>

</style>
